import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  OnDestroy,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import * as L from "leaflet";
import "leaflet-rotatedmarker";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_frozen from "@amcharts/amcharts4/themes/frozen";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { AppsService } from "src/app/shared/services/apps.service";
import moment from "moment";
import { differenceInCalendarDays } from "date-fns";
import { ActivatedRoute, Router } from "@angular/router";
import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "app-vehicle-dashboard",
  templateUrl: "./vehicle-dashboard.component.html",
  styleUrls: ["./vehicle-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VehicleDashboardComponent implements OnInit, OnDestroy {
  header_label = {
    name: "Vehicle Dashboard",
  };
  vehDta: any;
  selectedVehicle;
  vehicleMap;
  vehicleMap1;
  currentDate;
  slctdDt = new Date();
  today = new Date();
  init_lat = 17;
  init_lng = 81;
  oprtnlhrs: any;
  vstdLctns: any;
  oprtdNtoprtd: any;
  trpLst: any;
  showLdr = false;
  ttl_veh;
  VehLctns: any;
  ovrSpeed: any;
  eachVeh: any;
  fuelDta: any;
  vehRts: any = [];
  vehTrgts: any;
  vehnm: any;
  asrt_sts_nm: any;
  ctgrynm: any;
  grpnm: any;
  CrntDyDst: any;
  hrlyDta: any;
  postslctdDt: any;
  rteDta: any;
  dateFormat = "dd/MM/yyyy";
  selectedCtgry = 0;
  vehCtgrys: any;
  currentFrmtDate: string;
  params: any;
  curYr: any;
  selectedvndr;
  selectedtenant = 0;
  selectedtenantNm: string;
  vendorList: any;
  clntDtls: any;
  tntLst: any = [];
  errMsg: string;
  vehErrMsg;
  vstdLctnsMsg: string;
  ovrSpeedMsg: string;
  oprtnlhrsMsg: string;
  fuelDtaMsg: string;
  chart1Msg: string;
  chart2Msg: string;
  ttl_vehMsg: string;
  vehTrpLstMsg: string;
  tripsMsg: string;
  searchText;
  previousNotifications: any;
  previousNotificationsMsg: string;
  matchVehData: any;
  apply_actv = 0;
  vehOdmtr: any;
  devOdmtr: any;
  imei: any;
  chasis: any;
  userDtls: any;
  clap_in: number;
  showVndr: boolean = false;
  ShowClap: boolean = false;
  loading;
  data_lst_rcvd: any;
  speed: any;
  vehHrlyMsg: string;
  vehHrlyDtls: any;
  postData: any;
  dst_tvl_tdy: any;
  VhcleDetails: any;
  chart1: any;
  title;
  shwCrntLoc: boolean = true;
  shwplyback: boolean = false;
  heatData: any = [];
  heatmapLayer: any;
  circleMarker: any;
  crclArry: any = [];
  vehclesLst: any;
  svm_apfs_cd: any;
  slctdVehNm: any;
  cvrge_prcnt: number;
  avg_cvrg: string;
  schdPolylineArry: any = [];
  schdStartMarker: any;
  schdEndMarker: any;
  dstCnt: number;
  curDate;
  tripsData: any[];
  eachTrpData: any;
  columnDefs: any;
  schdPolyline: any;
  trvld_Polyline: any;
  CurrrentVehicleDtls: any;
  shwStpgWndw: boolean = false;
  stpgData = [];
  stpgcolumnDefs: any = [];
  filterPanelOpen: boolean = false;
  showMoreDetails: boolean = false;
  vehicleListOpen: boolean = true;
  ignitionStatus: string = "NA";
  fuelFillingData: any = [];
  fuelFillingMsg: string = "";
  fuelConsumed: number = 0;
  fuelChartData: any = [];
  fuelChartMsg: string = "";
  fuelChart: any;

  // Responsive drawer/modal width
  drawerWidth: string = "800px";

  // Auto-refresh properties
  autoRefreshEnabled: boolean = true;
  autoRefreshInterval: any = null;
  refreshCountdown: number = 30;
  countdownInterval: any = null;

  constructor(
    public apiServ: AppsService,
    private route: ActivatedRoute,
    public datepipe: DatePipe,
    public TransfereService: TransfereService,
    public router: Router,
    private message: NzMessageService
  ) {
    this.slctdDt = new Date();
    this.currentDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.currentFrmtDate = moment(this.slctdDt).format("DD-MM-YYYY");
    // console.log(this.currentDate,this.currentFrmtDate);
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    // this.selectedtenant = this.tntLst[0].tnt_id;
    if (this.tntLst.length > 1 && this.tntLst.length <= 8) {
      this.title = "Zone";
    } else {
      this.title = "ULB";
    }
    if (this.tntLst && this.tntLst.length > 0) {
      if (this.tntLst.length == 1) {
        this.selectedtenantNm =
          this.tntLst[0].tnt_dsply_nm || this.tntLst[0].tnt_nm;
      } else {
        this.selectedtenantNm = "";
      }
    }
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
    }
    this.route.queryParams.subscribe((params) => {
      this.params = params;
      // console.log(params.asrt_id)
      if (params) {
        this.selectedVehicle = this.params.asrt_id;
      }
    });
  }

  initialize = function () {
    //----------Map Initialization (Default openstreetmap  Layer) -- Leaflet OS Playback----------//
    try {
      this.vehicleMap = L.map("vehicleMap", {
        center: [this.init_lat, this.init_lng],
        zoom: 3,
        fullscreenControl: true,
      });

      // const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //   maxZoom: 18,
      //   minZoom: 3,
      //   attribution: ''
      // });
      const tiles = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
        {
          maxZoom: 18,
          minZoom: 3,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
          attribution: "",
        }
      );

      tiles.addTo(this.vehicleMap);
      this.vehicleMap.setView([this.clntDtls[0].lat, this.clntDtls[0].lng], 13);

      const fullscreenButton = L.control({ position: "topleft" });
      fullscreenButton.onAdd = (map) => {
        const div = L.DomUtil.create(
          "div",
          "leaflet-control-fullscreen leaflet-bar leaflet-control"
        );
        const link = L.DomUtil.create(
          "a",
          "leaflet-control-fullscreen-button",
          div
        );
        link.href = "#";
        link.title = "View Fullscreen";
        link.innerHTML = '<i class="fas fa-expand"></i>';

        L.DomEvent.on(link, "click", L.DomEvent.stopPropagation)
          .on(link, "click", L.DomEvent.preventDefault)
          .on(link, "click", () => {
            if (!document.fullscreenElement) {
              const element = document.getElementById("vehicleMap");
              if (element && element.requestFullscreen) {
                element.requestFullscreen();
              }
            } else {
              if (document.exitFullscreen) {
                document.exitFullscreen();
              }
            }
          });

        document.addEventListener("fullscreenchange", () => {
          if (document.fullscreenElement) {
            link.innerHTML = '<i class="fas fa-compress"></i>';
            link.title = "Exit Fullscreen";
            setTimeout(() => this.vehicleMap.invalidateSize(), 200);
          } else {
            link.innerHTML = '<i class="fas fa-expand"></i>';
            link.title = "View Fullscreen";
            setTimeout(() => this.vehicleMap.invalidateSize(), 200);
          }
        });

        return div;
      };
      fullscreenButton.addTo(this.vehicleMap);
      this.VehicleCurrLocPlotting();
    } catch (e) {
      // console.log("please check map Initialization of leaflet:" + e);
    }
  };
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, this.today) > 0;
  };

  ngOnInit() {
    this.curYr = moment(this.today).format("YYYY");
    this.updateDrawerWidth();
    this.get_totalVehiclesData();
    this.get_vehCategories();
    this.getVendors(this.selectedtenant);
    this.getPreviousNotifications(this.selectedVehicle);
    // console.log(this.selectedVehicle);
    this.getVehiclehourlyDtls(this.selectedVehicle);
    this.getVehInfo(this.selectedVehicle);
    this.get_distGraphsData(this.selectedVehicle);
    this.get_tripsGraphsData(this.selectedVehicle);
    this.initialize();

    // Start auto-refresh for vehicle list
    this.startAutoRefresh();
  }

  @HostListener("window:resize")
  onResize() {
    this.updateDrawerWidth();
  }

  updateDrawerWidth() {
    const width = window.innerWidth;
    if (width <= 640) {
      this.drawerWidth = "95%";
    } else if (width <= 1024) {
      this.drawerWidth = "90%";
    } else {
      this.drawerWidth = "800px";
    }
  }
  ontntSelect(value) {
    console.log(value);
    if (value == 0) {
      this.selectedtenant = 0;
      this.selectedtenantNm = `All ${this.title}'s Selected`;
    } else {
      for (let i = 0; i < this.tntLst.length; i++) {
        // console.log('in');
        if (this.tntLst[i].tnt_id == value) {
          this.selectedtenant = this.tntLst[i].tnt_id;
          this.selectedtenantNm =
            this.tntLst[i].tnt_dsply_nm || this.tntLst[i].tnt_nm;
          break;
        }
      }
    }
    this.getVendors(this.selectedtenant);
  }
  getVendors(slctTnt?) {
    console.log("ddddd");
    if (this.userDtls.dsgns_id == 1000032) {
      console.log("ffffffffffffffffffff");
      this.selectedvndr = this.userDtls.vndr_id;
      this.showVndr = true;
      this.apiServ
        .get(`billing/vendors/list/${this.selectedvndr}/byId`)
        .subscribe(
          (res) => {
            console.log(res);
            if (res["status"] == 200) {
              this.vendorList = res["data"];
              if (this.vendorList.length > 1) {
                this.selectedvndr = 0;
                console.log(this.selectedvndr, "this.selectedvndr");
              } else {
                this.selectedvndr = this.vendorList[0].vndr_id;
                console.log(this.selectedvndr, "this.selectedvndr");
              }
              // this.selectCategory(0,this.currentDate);
              this.get_totalVehiclesData();
            }
          },
          (err) => {
            // console.log("In errorr");
          }
        );
    } else if (this.clap_in == 0) {
      this.vendorList = [];
      console.log("fffffffffffffff");
      this.get_totalVehiclesData(); //#change
    } else {
      console.log("gggggggggg");
      this.showLdr = true;
      this.postslctdDt = {
        tnt_in: 1,
        slctd_tnt: slctTnt,
      };
      console.log(
        "vendorrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr",
        this.postslctdDt
      );
      let rte = `dashboard/enterprise/getVhclewise_vendorlst`;
      this.apiServ.post(this.postslctdDt, rte).subscribe(
        (res) => {
          console.log(res);
          if (res["status"] == 200) {
            this.showLdr = false;
            this.vendorList = res["data"];
            console.log(this.selectedvndr);
            if (this.vendorList.length > 1) {
              this.selectedvndr = 0;
            } else {
              this.selectedvndr = this.vendorList[0].vndr_id;
            }
            console.log(this.selectedvndr);
            // this.selectCategory(0,this.currentDate);
            this.get_totalVehiclesData();
          }
        },
        (err) => {
          console.log("In errorr");
        }
      );
    }
  }
  onvndrSelect(value) {
    //  console.log(this.selectedvndr);
    this.selectedvndr = value;
    // this.selectCategory(0,this.currentDate);
    this.get_totalVehiclesData();
  }
  vehMarker: any;
  selectVehicle(evnt) {
    this.clearPrevMarkers();
    console.log("in select vehicleeeeeeeeeeeeeeeeeeee");
    // console.log(evnt);
    for (let i = 0; i < this.ttl_veh.length; i++) {
      if (this.ttl_veh[i].asrt_id == evnt.asrt_id) {
        // console.log(this.ttl_veh[i].asrt_id == evnt.asrt_id, this.ttl_veh[i].asrt_id, evnt.asrt_id);
        this.ttl_veh[i].apply_actv = 1;
      } else {
        this.ttl_veh[i].apply_actv = 0;
      }
    }
    this.vehnm = evnt.asrt_nm;
    this.asrt_sts_nm = evnt.asrt_sts_nm;
    this.ctgrynm = evnt.asrt_ctgry_nm;
    this.grpnm = evnt.asrt_grp_nm;
    this.selectedVehicle = evnt.asrt_id;
    // this.VhcleDetails = evnt;
    this.getPreviousNotifications(this.selectedVehicle);
    this.getVehiclehourlyDtls(this.selectedVehicle);
    this.get_distGraphsData(this.selectedVehicle);
    this.get_tripsGraphsData(this.selectedVehicle);
    this.getVehInfo(this.selectedVehicle);
    this.getTripsData();
    // this.onChkCurrentLocation(this.shwCrntLoc);
    // this.VehicleCurrLocPlotting();
    this.get_allCtgrysData(evnt.asrt_id);
    // this.getVehiclehourlyDtls(evnt.asrt_id);
    // this.selectCategory(0,this.currentDate,evnt.asrt_id);
    // this.defaultSelectedVehicle(evnt);
    // this.get_distGraphsData(evnt.asrt_id);
    // this.get_tripsGraphsData(evnt.asrt_id);
    // this.getVehInfo(evnt.asrt_id);
    this.VehicleCurrLocPlotting();
  }
  defaultSelectedVehicle(evnt) {
    // console.log(evnt);

    if (this.vehMarker) {
      this.vehicleMap.removeLayer(this.vehMarker);
    }
    this.vehnm = evnt.asrt_nm;
    this.asrt_sts_nm = evnt.asrt_sts_nm;
    this.ctgrynm = evnt.asrt_ctgry_nm;
    this.grpnm = evnt.asrt_grp_nm;
    this.selectedVehicle = evnt.asrt_id;
    this.getPreviousNotifications(this.selectedVehicle);
    this.getVehiclehourlyDtls(this.selectedVehicle);
    this.get_distGraphsData(this.selectedVehicle);
    this.get_tripsGraphsData(this.selectedVehicle);
    this.getVehInfo(this.selectedVehicle);

    // Use the new tracking-style icon system
    const iconUrl = this.getMapVehicleIconUrl(evnt);
    const iconAngle = evnt.direction || evnt.drcn_ct || 0;

    var vehIcon = new L.Icon({
      iconUrl: iconUrl,
      iconSize: [100, null],
      iconAnchor: [37, 37],
      popupAnchor: [0, 0],
      shadowSize: [55, 55],
    });

    if (evnt.lat && evnt.lng) {
      const popupContent = `
        <div class="popup-content">
          <div class="popup-title">${evnt.asrt_nm || "Unknown Vehicle"}</div>
          <div class="popup-row"><span class="popup-label">Category:</span> <span class="popup-value">${
            evnt.asrt_ctgry_nm || "N/A"
          }</span></div>
          <div class="popup-row"><span class="popup-label">Group:</span> <span class="popup-value">${
            evnt.asrt_grp_nm || "N/A"
          }</span></div>
          <div class="popup-row"><span class="popup-label">Speed:</span> <span class="popup-value speed">${
            evnt.spd_ct || 0
          } km/h</span></div>
          <div class="popup-row"><span class="popup-label">Status:</span> <span class="popup-value">${
            evnt.live_status || evnt.asrt_sts_nm || "N/A"
          }</span></div>
        </div>
      `;

      this.vehMarker = L.marker([evnt.lat, evnt.lng], {
        icon: vehIcon,
      }).addTo(this.vehicleMap);

      // Try to set rotation if available
      if ((this.vehMarker as any).setRotationAngle) {
        (this.vehMarker as any).setRotationAngle(iconAngle + 270);
      }

      this.vehMarker
        .bindPopup(popupContent, {
          className: "vehicle-popup-white",
          maxWidth: 280,
          offset: [0, -10],
        })
        .openPopup();

      var bounds = [];
      bounds.push([evnt.lat, evnt.lng]);
      this.vehicleMap.fitBounds(bounds);
    }

    // this.selectCategory(0,this.currentDate,evnt.asrt_id);

    for (let i = 0; i < this.ttl_veh.length; i++) {
      if (this.ttl_veh[i].asrt_id == evnt.asrt_id) {
        // console.log(this.ttl_veh[i].asrt_id == evnt.asrt_id, this.ttl_veh[i].asrt_id, evnt.asrt_id);
        this.ttl_veh[i].apply_actv = 1;
      } else {
        this.ttl_veh[i].apply_actv = 0;
      }
    }
  }
  totCvrsBns = 0;
  totBins;
  CrntDyFuel;
  CrntDyFlAmt;
  vehTrpLst;
  get_allCtgrysData(veh_id) {
    //  console.log(veh_id)
    this.vehTrpLst = [];
    this.oprtdNtoprtd = [];
    this.ovrSpeed = [];
    this.hrlyDta = [];
    this.vstdLctns = [];
    this.VehLctns = [];
    this.oprtnlhrs = [];
    this.fuelDta = [];
    this.vehRts = [];
    this.eachVeh = [];
    this.showLdr = true;
    // this.apiServ.get(`dashboard/enterprise/vehicleOperated/${veh_id}`).subscribe((res) => {
    //   if (res['status'] == 200) {
    //     var res_data = res['data'];
    //     if (res_data) {
    //       this.oprtdNtoprtd = res['data'];
    //     }
    //   }
    // }, (err) => {
    //   // console.log(err);
    // });
    this.apiServ
      .get(`dashboard/enterprise/echVehicleOvrSpeed/${veh_id}`)
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data) {
              this.ovrSpeed = res["data"];
              if (this.ovrSpeed.length == 0) {
                this.ovrSpeedMsg = "Speed Violation not found to this vehicle.";
              } else {
                this.ovrSpeedMsg = "";
              }
            }
            this.showLdr = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );

    // this.apiServ.get(`dashboard/enterprise/distanceCoveredByasrtId/${veh_id}`).subscribe((res) => {
    //   if (res['status'] == 200) {
    //     var res_data = res['data'];
    //     if (res_data) {
    //       this.hrlyDta = res['data'];
    //     }
    //     this.showLdr = false;
    //   }
    // }, (err) => {
    //   // console.log(err);
    // });

    this.apiServ
      .get(`dashboard/enterprise/echVehicleLocations/${veh_id}`)
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data) {
              this.vstdLctns = res["data"];
              if (this.vstdLctns.length == 0) {
                this.vstdLctnsMsg =
                  "Visited locations not found to this vehicle.";
              } else {
                this.vstdLctnsMsg = "";
              }
            }
            this.showLdr = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );

    // this.apiServ.get(`dashboard/enterprise/locations/${veh_id}`).subscribe((res) => {
    //   if (res['status'] == 200) {
    //     var res_data = res['data'];
    //     if (res_data) {
    //       this.VehLctns = res['data'];
    //       // console.log(this.VehLctns);
    //       this.totBins = this.VehLctns.length;
    //       for (let i = 0; i < this.VehLctns.length - 1; i++) {
    //           if (this.VehLctns[i].covered_in == 1) {
    //               this.totCvrsBns = this.totCvrsBns + 1;
    //           }
    //       }
    //     }
    //     this.showLdr = false;

    //   }
    // }, (err) => {
    //   // console.log(err);
    // });

    this.apiServ.get(`dashboard/enterprise/operational/${veh_id}`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          // if (res_data) {
          this.oprtnlhrs = res["data"];
          // console.log(this.oprtnlhrs);
          if (this.oprtnlhrs.length == 0) {
            this.oprtnlhrsMsg = "No Operational Details found to this vehicle.";
          } else {
            this.oprtnlhrsMsg = "";
          }
          // }
          this.showLdr = false;
        }
      },
      (err) => {
        // console.log(err);
      }
    );

    this.apiServ.get(`dashboard/enterprise/vehicleRoutes/${veh_id}`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          if (res_data) {
            this.vehRts = res["data"];
            console.log(this.vehRts);
          }
          this.showLdr = false;
        }
      },
      (err) => {
        // console.log(err);
      }
    );

    // this.postslctdDt = {
    //   dt: this.currentDate,
    //   asrt_id: veh_id,
    //   tnt: this.selectedtenant,
    //   ctgry: this.selectedCtgry,
    //   vndr: this.selectedvndr,
    //   tnt_in: 1
    // }
    //  console.log('posting', this.postslctdDt);
    // const rte = `dashboard/enterprise/get_SnglevehTrpsLst`;
    // this.apiServ.post(this.postslctdDt, rte).subscribe((res) => {
    //   if (res['status'] == 200) {
    //     var res_data = res['data'];
    //     if (res_data) {
    //       this.vehTrpLst = res['data'];
    //       console.log(this.vehTrpLst)
    //     //   if(!this.vehicleMap1){
    //     //   this.vehicleMap1 = L.map('vehicleMap', {
    //     //     center: [this.init_lat, this.init_lng],
    //     //     zoom: 3
    //     //   });

    //     //   // const tiles1 = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //     //   //   maxZoom: 18,
    //     //   //   minZoom: 3,
    //     //   //   attribution: ''
    //     //   // });
    //     //   const tiles1 = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
    //     //     maxZoom: 18,
    //     //     minZoom: 3,
    //     //     subdomains:['mt0','mt1','mt2','mt3'],
    //     //     attribution: ''            });
    //     //   tiles1.addTo(this.vehicleMap1);
    //     //   this.vehicleMap1.setView([this.clntDtls[0].lat, this.clntDtls[0].lng], 13)
    //     // }
    //       if(this.vehTrpLst.length == 0){
    //         this.vehTrpLstMsg = 'Trips not found to this vehicle.';
    //       }else{
    //         this.vehTrpLstMsg = '';
    //       }
    //     }

    //     this.showLdr = false;
    //   }
    // }, (err) => {
    //   // console.log(err);
    // });

    this.getPreviousNotifications(veh_id);
    this.getVehiclehourlyDtls(veh_id);
    this.get_distGraphsData(veh_id);
    this.get_tripsGraphsData(veh_id);
    this.getVehInfo(veh_id);

    // // get each vehicle details by asrt_id
    // this.apiServ.get(`dashboard/enterprise/getVehicleDetailsById/${veh_id}`).subscribe((res) => {
    //   if (res['status'] == 200) {
    //     var res_data = res['data'];
    //     if (res_data) {
    //       this.vehCtgrys = res['data'];
    //       // console.log(this.vehCtgrys);
    //       this.selectedCtgry = 0;
    //     }
    //     this.showLdr = false;
    //   }
    // }, (err) => {
    //   // console.log(err);
    // });
  }

  onChange(e): void {
    this.selectedCtgry = 0;
    this.slctdDt = e;
    this.currentDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // this.selectCategory(0,this.currentDate);
    this.get_vehCategories();
  }
  get_vehCategories(): any {
    this.showLdr = true;
    this.apiServ.get(`dashboard/enterprise/get_vehCtgrys`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          if (res_data) {
            this.vehCtgrys = res["data"];
            this.selectedCtgry = 0;
          }
          this.showLdr = false;
        }
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  selectCategory(evnt, dt?, vehID?) {
    console.log("selectCategory", evnt, this.selectedVehicle);
    this.showLdr = true;
    this.vehTrpLst = [];
    this.currentDate = moment(dt).format("YYYY-MM-DD");
    //  console.log(this.currentDate);
    this.selectedCtgry = evnt;
    this.get_totalVehiclesData();
    // this.selectedVehicle = vehID;
    // this.postslctdDt = {
    //   dt: this.currentDate,
    //   asrt_id: this.selectedVehicle,
    //   tnt: this.selectedtenant,
    //   ctgry: this.selectedCtgry,
    //   vndr: this.selectedvndr,
    //   tnt_in: 1
    // }
    // console.log('posting Dataaaaaaaaaaaaaaaaaaaaaaaaaaa', this.postslctdDt);

    // const rte = `dashboard/enterprise/get_SnglevehTrpsLst`;
    // this.apiServ.post(this.postslctdDt, rte).subscribe((res) => {
    //   if (res['status'] == 200) {
    //     var res_data = res['data'];
    //     if (res_data) {
    //       this.vehTrpLst = res['data'];
    //         console.log(this.vehTrpLst)
    //         if(this.vehTrpLst.length == 0){
    //           this.vehTrpLstMsg = 'Trips not found to this vehicle.';
    //         }else{
    //           this.vehTrpLstMsg = '';
    //         }
    //     }
    //     this.showLdr = false;
    //   }
    // }, (err) => {
    //   // console.log(err);
    // });
  }

  startPBMarker: any;
  endPBMarker: any;
  startPBMarker1: any;
  endPBMarker1: any;
  polylinePoints: any;
  actl_Polyline: any;
  route_Polyline: any = [];
  getTripMap(c, dt) {
    this.showLdr = true;
    this.polylinePoints = JSON.parse(c.rte_arc_lne_tx);

    if (this.route_Polyline) {
      this.vehicleMap1.removeLayer(this.route_Polyline);
    }
    if (this.startPBMarker) {
      this.vehicleMap1.removeLayer(this.startPBMarker);
    }

    if (this.endPBMarker) {
      this.vehicleMap1.removeLayer(this.endPBMarker);
    }

    if (this.actl_Polyline) {
      this.vehicleMap1.removeLayer(this.actl_Polyline);
    }
    if (this.startPBMarker1) {
      this.vehicleMap1.removeLayer(this.startPBMarker1);
    }

    if (this.endPBMarker1) {
      this.vehicleMap1.removeLayer(this.endPBMarker1);
    }
    // ----------Fence Start Area (flag position) -- Leaflet OS ----------//
    var startIcon = new L.Icon({
      iconUrl: "/assets/images/markers/playback/startPoint.png",
      iconSize: [42, 45],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });
    this.startPBMarker = L.marker(this.polylinePoints[0], {
      icon: startIcon,
    }).addTo(this.vehicleMap1);
    // ----------Fence END Area (flag position) -- Leaflet OS ----------//
    var endIcon = new L.Icon({
      iconUrl: "/assets/images/markers/playback/endPoint.png",
      iconSize: [42, 45],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });
    var k = this.polylinePoints.length - 1;
    this.endPBMarker = L.marker(this.polylinePoints[k], {
      icon: endIcon,
    }).addTo(this.vehicleMap1);
    if (c) {
      this.route_Polyline = L.polyline(JSON.parse(c.rte_arc_lne_tx), {
        color: "#008000",
        weight: 5,
        lineCap: "butt",
        opacity: 0.6,
        smoothFactor: 10.0,
        lineJoin: "round",
      }).addTo(this.vehicleMap1);
    }
    this.vehicleMap1.fitBounds(this.route_Polyline.getBounds());
    // console.log(c,dt);
    this.currentDate = moment(dt).format("YYYY-MM-DD");
    this.postslctdDt = {
      dt: this.currentDate,
      data: c,
    };
    const rte = `dashboard/enterprise/get_tripTrvlRoute`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.showLdr = false;
          var res_data = res["data"];
          if (res_data && res_data.length > 0) {
            this.rteDta = res["data"];
            console.log(this.rteDta);
            var restr = "";
            var tmp;
            for (var i = 0; i < this.rteDta.length; i++) {
              restr +=
                restr == ""
                  ? "[" + this.rteDta[i].lat + "," + this.rteDta[i].lng + "]"
                  : ",[" + this.rteDta[i].lat + "," + this.rteDta[i].lng + "]";
            }
            // console.log("[" + restr + "]");

            // ----------Fence Start Area (flag position) -- Leaflet OS ----------//
            var startIcon1 = new L.Icon({
              iconUrl: "/assets/images/markers/playback/startPoint.png",
              iconSize: [42, 45],
              iconAnchor: [12, 41],
              popupAnchor: [1, -34],
              shadowSize: [41, 41],
            });
            this.startPBMarker1 = L.marker(
              [this.rteDta[0].lat, this.rteDta[0].lng],
              {
                icon: startIcon1,
              }
            ).addTo(this.vehicleMap1);
            // ----------Fence END Area (flag position) -- Leaflet OS ----------//
            var endIcon1 = new L.Icon({
              iconUrl: "/assets/images/markers/playback/endPoint.png",
              iconSize: [42, 45],
              iconAnchor: [12, 41],
              popupAnchor: [1, -34],
              shadowSize: [41, 41],
            });
            var k1 = this.rteDta.length - 1;
            this.endPBMarker1 = L.marker(this.rteDta[k], {
              icon: endIcon1,
            }).addTo(this.vehicleMap1);

            this.actl_Polyline = L.polyline(JSON.parse("[" + restr + "]"), {
              color: "red",
              weight: 4,
              lineCap: "butt",
              opacity: 0.5,
              smoothFactor: 10.0,
              lineJoin: "round",
            }).addTo(this.vehicleMap1);
          }
        }
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  get_totalVehiclesData() {
    this.showLdr = true;
    this.ttl_veh = [];
    this.postslctdDt = {
      dt: this.currentDate,
      selectedtenant: this.selectedtenant,
      selectedctgry: this.selectedCtgry,
      selectedvndr: this.selectedvndr,
      tnt_in: 1,
    };
    console.log("posting Total Vehicles", this.postslctdDt);
    const rte = `dashboard/enterprise/total_vehicles`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          if (res_data) {
            this.ttl_veh = res["data"];
            console.log(this.ttl_veh);
            for (let i = 0; i < this.ttl_veh.length; i++) {
              this.ttl_veh[i]["apply_actv"] = 0;
              // if(this.ttl_veh[i].asrt_id == evnt.asrt_id){
              //   console.log(this.ttl_veh[i].asrt_id == evnt.asrt_id,this.ttl_veh[i].asrt_id,evnt.asrt_id);
              //   this.apply_actv = 1;
              // } else {this.apply_actv = 0;}
            }
            console.log(this.ttl_veh);
            this.showLdr = false;
            // console.log(this.params.length)
            if (this.params.asrt_id != undefined) {
              this.selectedVehicle = this.params.asrt_id;
            } else {
              if (this.ttl_veh.length == 0) {
                this.ttl_vehMsg = "No vehicles found in the selected filters.";
                this.selectedVehicle = 0;
              } else {
                this.selectedVehicle = this.ttl_veh[0].asrt_id;
                this.ttl_vehMsg = "";
              }
            }
            console.log(this.selectedVehicle);

            this.get_allCtgrysData(this.selectedVehicle);
            this.get_distGraphsData(this.selectedVehicle);
            this.get_tripsGraphsData(this.selectedVehicle);

            // this.selectCategory(0,this.currentDate,this.selectedVehicle);
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getPreviousNotifications(veh_id) {
    this.showLdr = true;
    this.previousNotifications = [];
    const rte = `dashboard/enterprise/last_10VehNtfcntsLst/${veh_id}`;
    this.apiServ.get(rte).subscribe(
      (res) => {
        this.showLdr = false;
        if (res["status"] == 200) {
          let data = res["data"];
          this.previousNotifications = data;
          console.log(this.previousNotifications);
        }
        if (this.previousNotifications == 0) {
          this.previousNotificationsMsg =
            "Notifications not found to this vehicle.";
        } else {
          this.previousNotificationsMsg = "";
        }
      },
      (error) => {
        this.showLdr = false;
      }
    );
  }

  getVehiclehourlyDtls(veh_id): any {
    console.log("in getVehiclehourlyDtls");
    this.vehHrlyDtls = [];
    this.showLdr = true;
    console.log(veh_id);
    this.postData = {
      selectedVehicle: this.selectedVehicle,
    };
    const rte = `drivers/vehicle/hourly_distance`;
    let chart = am4core.create("hepachartdiv", am4charts.XYChart);
    chart.data = [];
    console.log(this.postData);
    this.apiServ.post(this.postData, rte).subscribe(
      (res) => {
        this.vehHrlyDtls = res["data"];
        console.log(this.vehHrlyDtls);
        this.vehHrlyDtls.forEach((obj) => {
          if (obj.dst == null) {
            obj.dst = 0;
          } else {
            obj.dst = obj.dst;
          }
        });
        chart.data = this.vehHrlyDtls;

        chart.maskBullets = true;

        var xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        var yAxis = chart.yAxes.push(new am4charts.CategoryAxis());

        xAxis.dataFields.category = "trvl_hr";
        yAxis.dataFields.category = "trvl_dt";

        xAxis.title.text = "------Hour-------";
        yAxis.title.text = "------Date-------";

        xAxis.renderer.grid.template.disabled = true;
        xAxis.renderer.minGridDistance = 40;

        yAxis.renderer.grid.template.disabled = true;
        yAxis.renderer.inversed = true;
        yAxis.renderer.minGridDistance = 10;
        yAxis.renderer.fontSize = 11;

        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryX = "trvl_hr";
        series.dataFields.categoryY = "trvl_dt";
        series.dataFields.value = "dst";
        series.sequencedInterpolation = true;
        series.defaultState.transitionDuration = 3000;

        var bgColor = new am4core.InterfaceColorSet().getFor("background");

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 1;
        columnTemplate.strokeOpacity = 0.2;
        // columnTemplate.strokeWidth = 2;
        // columnTemplate.strokeOpacity = 1;
        columnTemplate.stroke = am4core.color("eff567");
        columnTemplate.tooltipText = "{dst}";
        columnTemplate.width = am4core.percent(100);
        columnTemplate.height = am4core.percent(100);

        series.heatRules.push({
          target: columnTemplate,
          property: "fill",
          min: am4core.color(bgColor),
          max: chart.colors.getIndex(0),
        });
        var legend = new am4charts.Legend();
        legend.parent = chart.chartContainer;
        legend.data = [
          {
            name: "Distance Covered",
            fill: am4core.color("#bec4f8"),
          },
        ];

        // series.heatRules.push({
        // 	target:columnTemplate,
        // 	property:"fill",
        // 	min:am4core.color("#f5f6fe"),
        // 	max:am4core.color("#554abd"),
        // 	minValue: 2000,
        // 	maxValue: 5000
        //   });

        // heat legend
        var heatLegend = chart.bottomAxesContainer.createChild(
          am4charts.HeatLegend
        );
        heatLegend.width = am4core.percent(100);
        heatLegend.series = series;
        heatLegend.valueAxis.renderer.labels.template.fontSize = 9;
        heatLegend.valueAxis.renderer.minGridDistance = 30;

        let valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{dst}";
        valueLabel.label.fontSize = 15;

        // columnTemplate1.width = 60;
        columnTemplate.column.cornerRadiusTopLeft = 3;
        columnTemplate.column.cornerRadiusTopRight = 3;
        columnTemplate.column.cornerRadiusBottomLeft = 3;
        columnTemplate.column.cornerRadiusBottomRight = 3;

        // heat legend behavior
        series.columns.template.events.on("over", function (event) {
          handleHover(event.target);
        });

        series.columns.template.events.on("hit", function (event) {
          handleHover(event.target);
        });

        function handleHover(column) {
          if (!isNaN(column.dataItem.value)) {
            heatLegend.valueAxis.showTooltipAt(column.dataItem.value);
          } else {
            heatLegend.valueAxis.hideTooltip();
          }
        }

        series.columns.template.events.on("out", function (event) {
          heatLegend.valueAxis.hideTooltip();
        });

        if (this.vehHrlyDtls.length == 0) {
          this.vehHrlyMsg = "Hourly Distance not found to this driver.";
        } else {
          this.vehHrlyMsg = "";
        }
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }
  get_distGraphsData(veh_id) {
    this.showLdr = true;

    // this.eachVeh = [];
    this.apiServ.get(`dashboard/enterprise/vehicleTargets/${veh_id}`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          // var res_data = res['data'].results;
          if (res["data"].results) {
            let chart1 = am4core.create(
              "lastSevenDaysDistanceChart",
              am4charts.XYChart
            );
            chart1.data = [];
            chart1.data = res["data"].results;
            this.showLdr = false;
            // Create axes
            let categoryAxis1 = chart1.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis1.dataFields.category = "dt";
            categoryAxis1.renderer.grid.template.location = 0;
            categoryAxis1.renderer.minGridDistance = 30;
            categoryAxis1.title.text = ` ----- Date(${this.curYr}) ----- `;
            let valueAxis1 = chart1.yAxes.push(new am4charts.ValueAxis());
            valueAxis1.title.text = " ----- Distance Covered -----";
            valueAxis1.cursorTooltipEnabled = false;
            // let series1 = chart1.series.push(new am4charts.ColumnSeries());
            // series1.dataFields.valueY = "mn_dst_ct";
            // series1.dataFields.categoryX = "dt";
            // series1.clustered = false;
            // series1.tooltipText = "Total Distance in {categoryX}: [bold]{valueY}[/]";
            // series1.columns.template.fill = am4core.color("#a9dcf4");
            // series1.columns.template.stroke = am4core.color("#a9dcf4");

            let series2 = chart1.series.push(new am4charts.ColumnSeries());
            series2.dataFields.valueY = "trp_dst";
            series2.dataFields.categoryX = "dt";
            series2.clustered = false;
            series2.columns.template.width = am4core.percent(50);
            series2.tooltipText =
              "Covered Distance in {categoryX}: [bold]{valueY}[/]";
            series2.columns.template.fill = am4core.color("#ffc107");
            series2.columns.template.stroke = am4core.color("#ffc107");
            let valueLabel = series2.bullets.push(new am4charts.LabelBullet());
            valueLabel.label.text = "{trp_dst}";
            valueLabel.label.fontSize = 15;
            let columnTemplate1 = series2.columns.template;
            columnTemplate1.strokeWidth = 1;
            chart1.cursor = new am4charts.XYCursor();
            chart1.cursor.lineX.disabled = true;
            chart1.cursor.lineY.disabled = true;

            //   for (let j = 0; j <= chart1.data.length - 1; j++) {
            //     if (chart1.data[j].dt == this.currentFrmtDate) {
            //         this.CrntDyDst = chart1.data[chart1.data.length - 1].trp_dst;
            //     }
            // }
            this.showLdr = false;
            if (chart1.data.length == 0) {
              this.chart1Msg = "Last 7Days Distance not found to this vehicle.";
            } else {
              this.chart1Msg = "";
            }
          }
        }
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  get_tripsGraphsData(veh_id) {
    this.showLdr = true;
    this.eachVeh = [];
    this.apiServ.get(`dashboard/enterprise/vehicleTargets/${veh_id}`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          // var res_data = res['data'].results;

          if (res["data"].results) {
            let chart2 = am4core.create(
              "lastSevenDaysChart",
              am4charts.XYChart
            );
            chart2.data = [];
            chart2.data = res["data"].results;
            this.showLdr = false;
            this.eachVeh = chart2.data;
            if (chart2.data.length == 0) {
              this.chart2Msg = "Last 7Days Trips not found to this vehicle.";
              this.tripsMsg = "Last 7Days Trips not found to this vehicle.";
            } else {
              this.chart2Msg = "";
              this.tripsMsg = "";
            }
            let categoryAxis = chart2.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "dt";
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.minGridDistance = 30;
            categoryAxis.title.text = ` ----- Date(${this.curYr}) ----- `;
            let valueAxis = chart2.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = " ----- Trip Count -----";
            valueAxis.cursorTooltipEnabled = false;
            let series3 = chart2.series.push(new am4charts.ColumnSeries());
            series3.dataFields.valueY = "mn_trp_ct";
            series3.dataFields.categoryX = "dt";
            series3.clustered = false;
            series3.tooltipText =
              "Targeted Trips in {categoryX}: [bold]{valueY}[/]";
            series3.columns.template.fill = am4core.color("#55ac73");
            series3.columns.template.stroke = am4core.color("#55ac73");

            let series4 = chart2.series.push(new am4charts.ColumnSeries());
            series4.dataFields.valueY = "trp_cnt";
            series4.dataFields.categoryX = "dt";
            series4.clustered = false;
            series4.columns.template.width = am4core.percent(50);
            series4.tooltipText =
              "Covered Trips in {categoryX}: [bold]{valueY}[/]";
            series4.columns.template.fill = am4core.color("#80cf9b");
            series4.columns.template.stroke = am4core.color("#80cf9b");

            let valueLabel = series4.bullets.push(new am4charts.LabelBullet());
            valueLabel.label.text = "{trp_cnt}";
            valueLabel.label.fontSize = 15;
            let columnTemplate1 = series4.columns.template;
            columnTemplate1.strokeWidth = 1;

            chart2.cursor = new am4charts.XYCursor();
            chart2.cursor.lineX.disabled = true;
            chart2.cursor.lineY.disabled = true;
            this.showLdr = false;
            // for (let i = 0; i < this.eachVeh.length - 1; i++) {
            //   if (this.eachVeh[this.eachVeh.length - 1].asrt_id == veh_id) {
            // this.vehnm = this.eachVeh[this.eachVeh.length - 1].asrt_nm;
            // this.asrt_sts_nm = this.eachVeh[this.eachVeh.length - 1].asrt_sts_nm;
            // this.ctgrynm = this.eachVeh[this.eachVeh.length - 1].asrt_ctgry_nm;
            // this.grpnm = this.eachVeh[this.eachVeh.length - 1].asrt_grp_nm;
            // this.matchVehData = this.eachVeh[this.eachVeh.length - 1];
            // this.vehOdmtr = this.eachVeh[this.eachVeh.length - 1].veh_odmtr_ct;
            // this.devOdmtr = this.eachVeh[this.eachVeh.length - 1].dvce_odmtr_ct;
            // this.data_lst_rcvd = this.eachVeh[this.eachVeh.length - 1].data_received_ts;
            // this.speed = this.eachVeh[this.eachVeh.length - 1].speed_ct;
            // this.CrntDyDst = this.eachVeh[this.eachVeh.length - 1].trp_dst;
            // this.dst_tvl_tdy = this.eachVeh[this.eachVeh.length - 1].tdy_dst
            // }
            // }
            // console.log(this.asrt_sts_nm)
            // console.log('this.matchVehData', this.matchVehData);
            // this.defaultSelectedVehicle(this.matchVehData);
          } else {
            this.eachVeh = [];
            this.chart2Msg = "Last 7Days Trips not found to this vehicle.";
            this.tripsMsg = "Last 7Days Trips not found to this vehicle.";
          }
          // if (res_data. == undefined) {
          //   this.errMsg = `Last 7Days Trips not found to this vehicle.`
          // }
          // else {
          //   this.errMsg = ``
          // }
          this.showLdr = false;
        }
      },
      (err) => {
        this.eachVeh = [];
        this.chart2Msg = "Last 7Days Trips not found to this vehicle.";
        this.tripsMsg = "Last 7Days Trips not found to this vehicle.";
        this.showLdr = false;
        // console.log(err);
      }
    );
  }
  getVehInfo(asrt_id) {
    this.VhcleDetails = [];
    this.apiServ
      .get(`drivers/vehicles/vehicleById/${asrt_id}`)
      .subscribe((res) => {
        if (res["status"] == 200) {
          // var res_data = res['data'];
          // if (res_data) {
          this.VhcleDetails = res["data"][0];
          this.vehnm = this.VhcleDetails.asrt_nm;
          this.asrt_sts_nm = this.VhcleDetails.asrt_sts_nm;
          this.ctgrynm = this.VhcleDetails.asrt_ctgry_nm;
          this.grpnm = this.VhcleDetails.asrt_grp_nm;
          this.matchVehData = this.VhcleDetails;
          this.vehOdmtr = this.VhcleDetails.veh_odmtr_ct;
          this.devOdmtr = this.VhcleDetails.dvce_odmtr_ct;
          this.imei = this.VhcleDetails.dev_imei_nu;
          this.chasis = this.VhcleDetails.asrt_chses_nu;
          this.data_lst_rcvd = this.VhcleDetails.data_received_ts;
          this.speed = this.VhcleDetails.speed_ct;
          this.CrntDyDst = this.VhcleDetails.trp_dst;
          this.dst_tvl_tdy = this.VhcleDetails.tdy_dst;
          this.ignitionStatus =
            this.VhcleDetails.igntn_in == 1
              ? "ON"
              : this.VhcleDetails.igntn_in == 0
              ? "OFF"
              : "NA";
          this.getTripsData();
          this.onChkCurrentLocation(this.shwCrntLoc);
          this.getFuelFillingData(asrt_id);
          this.getFuelChartData(asrt_id);
        }
      });
  }
  onChkPlyback(evt) {
    this.shwplyback = evt;
    if (this.shwplyback == true) {
      this.shwCrntLoc = false;
      this.getPlayback();
    } else {
      this.eachTrpData = null;
      this.shwCrntLoc = true;
      // this.getHeatMap();
    }
  }
  getTripsData() {
    this.tripsData = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
      asrt_id: this.selectedVehicle,
    };
    // console.log(postslctdDt, "postslctdDt");
    let rte = `dashboard/enterprise/wards/vehicles/getCoveredTripsDetails`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.tripsData = res["data"];
          // console.log(this.tripsData, "trpsssssssssdat");
          this.dstCnt = 0;
          this.tripsData.forEach((t) => {
            this.dstCnt += t.actl_trvl_dstne_ct;
          });
          this.columnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 50,
              filter: false,
            },
            { headerName: "ULB", field: "ZONE", alignment: "left" },
            // { headerName: 'Sachivalayam', field: 'svm_nm', alignment: 'left' },
            {
              headerName: "Zone",
              field: "asrt_grp_nm",
              alignment: "left",
              fixed: true,
            },
            { headerName: "Vehicle", field: "VEHICLE", alignment: "Center" },
            {
              headerName: "Trip Number",
              field: "TRIP_NUM",
              alignment: "Center",
            },
            { headerName: "Source", field: "SOURCE", alignment: "left" },
            {
              headerName: "Destination",
              field: "DESTINATION",
              alignment: "left",
            },
            {
              headerName: "Start Time",
              field: "ACTUAL_START",
              alignment: "Center",
            },
            {
              headerName: "End Time",
              field: "ACTUAL_END",
              alignment: "Center",
            },
            {
              headerName: "Schedule Distance (In KM)",
              field: "km",
              alignment: "Center",
            },
            {
              headerName: "Travelled Distance (In KM)",
              field: "actl_trvl_dstne_ct",
              alignment: "Center",
            },
            {
              headerName: "Trip Status",
              field: "TripStatus",
              alignment: "left",
            },
            // { headerName: 'Coverage %', field: 'cvrg_prcntg_ct', alignment: 'Center' },
            {
              headerName: "Route Deviated",
              field: "Deviation",
              alignment: "Center",
            },
          ];
        }
        this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  getPlayback() {
    this.clearPrevMarkers();
    // this.eachTrpData = data.data;
    console.log("in gettingggggggggggg playyyyyyyy");
    this.shwCrntLoc = false;
    this.shwplyback = true;
    this.showLdr = true;
    console.log(this.tripsData);
    if (this.tripsData && this.tripsData.length > 0) {
      if (this.vehMarker) {
        this.vehicleMap.removeLayer(this.vehMarker);
        this.vehicleMap.closePopup();
      }
      if (this.schdPolylineArry) {
        for (let s = 0; s < this.schdPolylineArry.length; s++) {
          this.vehicleMap.removeLayer(this.schdPolylineArry[s].plylns);
        }
      }
      if (this.trvld_Polyline) {
        this.vehicleMap.removeLayer(this.trvld_Polyline);
      }
      if (this.crclArry) {
        for (let c = 0; c < this.crclArry.length; c++) {
          this.vehicleMap.removeLayer(this.crclArry[c].crcls);
        }
      }
      if (this.schdStartMarker) {
        this.vehicleMap.removeLayer(this.schdStartMarker);
      }
      if (this.schdEndMarker) {
        this.vehicleMap.removeLayer(this.schdEndMarker);
      }
      // plotting schedule polyline on map
      for (let r = 0; r < this.tripsData.length; r++) {
        this.schdPolyline = L.polyline(
          [JSON.parse(this.tripsData[r].rte_arc_lne_tx)],
          {
            color: "#008000",
            weight: 5,
            lineCap: "butt",
            opacity: 0.6,
            smoothFactor: 10.0,
            lineJoin: "round",
          }
        ).addTo(this.vehicleMap);
        this.schdPolylineArry.push({ plylns: this.schdPolyline });
        this.vehicleMap.fitBounds(this.schdPolyline.getBounds());
        var startIcon = new L.Icon({
          iconUrl: "/assets/images/markers/mapIcons/m/location.png",
          iconSize: [33, 33],
          iconAnchor: [16, 28],
        });

        // Create LayerGroup if not exists
        if (!this.schdMarkerGroup) {
          this.schdMarkerGroup = L.layerGroup();
          this.vehicleMap.addLayer(this.schdMarkerGroup);
        }
        this.schdStartMarker = L.marker(
          [
            JSON.parse(this.tripsData[0].rte_arc_lne_tx)[0][0],
            JSON.parse(this.tripsData[0].rte_arc_lne_tx)[0][1],
          ],
          {
            icon: startIcon,
          }
        )
          .bindTooltip(this.tripsData[0].SOURCE, {
            permanent: true,
            opacity: 0.7,
          })
          .openTooltip();
        this.schdMarkerGroup.addLayer(this.schdStartMarker);

        // ----------Fence END Area (flag position) -- Leaflet OS ----------//
        var endIcon = new L.Icon({
          iconUrl: "/assets/images/markers/mapIcons/m/location.png",
          iconSize: [33, 33],
          iconAnchor: [16, 28],
        });
        let k =
          JSON.parse(this.tripsData[this.tripsData.length - 1].rte_arc_lne_tx)
            .length - 1;
        // if (c.end_fnce_lat && c.end_fnce_lng) {

        this.schdEndMarker = L.marker(
          [
            JSON.parse(
              this.tripsData[this.tripsData.length - 1].rte_arc_lne_tx
            )[k][0],
            JSON.parse(
              this.tripsData[this.tripsData.length - 1].rte_arc_lne_tx
            )[k][1],
          ],
          {
            icon: endIcon,
          }
        )
          .bindTooltip(this.tripsData[this.tripsData.length - 1].DESTINATION, {
            permanent: true,
            opacity: 0.7,
          })
          .openTooltip();
        this.schdMarkerGroup.addLayer(this.schdEndMarker);

        // }
      }

      let strt_ts = this.curDate + " 00:00:00";
      let end_ts = this.curDate + " 23:59:59";
      var postslctdDt = {
        dt: this.curDate,
        data: {
          dev_imei_nu: this.tripsData[0]?.dev_imei_nu,
          start_tm: this.datepipe.transform(strt_ts, "yyyy-MM-dd HH:mm"),
          end_tm: this.datepipe.transform(end_ts, "yyyy-MM-dd HH:mm"),
        },
      };
      this.showLdr = true;
      const rte = `dashboard/enterprise/get_tripTrvlRoute`;
      this.apiServ.post(postslctdDt, rte).subscribe((res) => {
        if (res["status"] == 200) {
          this.rteDta = res["data"];
          console.log(this.rteDta);
          var bnd_strng = [];
          for (let l = 0; l < this.rteDta.length; l++) {
            bnd_strng.push([this.rteDta[l].lat, this.rteDta[l].lng]);
          }
          this.showLdr = false;
          this.trvld_Polyline = L.polyline([bnd_strng], {
            color: "red",
            weight: 4,
            lineCap: "butt",
            opacity: 0.5,
            smoothFactor: 10.0,
            lineJoin: "round",
          }).addTo(this.vehicleMap);
          this.vehicleMap.fitBounds(this.trvld_Polyline.getBounds());
        } else {
          this.showLdr = false;
        }
      });
    } else {
      this.showLdr = false;
      this.createMessage("warning", "No trips Found for selected vehicle");
    }
  }
  onChkCurrentLocation(evt) {
    this.shwCrntLoc = evt;
    if (this.shwCrntLoc == true) {
      this.shwplyback = false;
      if (this.vehMarker) {
        this.vehicleMap.removeLayer(this.vehMarker);
      }
      if (this.schdPolylineArry) {
        for (let s = 0; s < this.schdPolylineArry.length; s++) {
          this.vehicleMap.removeLayer(this.schdPolylineArry[s].plylns);
        }
      }
      if (this.trvld_Polyline) {
        this.vehicleMap.removeLayer(this.trvld_Polyline);
      }
      if (this.crclArry) {
        for (let c = 0; c < this.crclArry.length; c++) {
          this.vehicleMap.removeLayer(this.crclArry[c].crcls);
        }
      }
      if (this.schdStartMarker) {
        this.vehicleMap.removeLayer(this.schdStartMarker);
      }
      if (this.schdEndMarker) {
        this.vehicleMap.removeLayer(this.schdEndMarker);
      }
      this.VehicleCurrLocPlotting();
    } else {
      this.shwplyback = true;
      this.getPlayback();
    }
  }
  VehicleCurrLocPlotting() {
    this.clearPrevMarkers();
    this.shwCrntLoc = true;
    this.shwplyback = false;
    if (this.vehMarker) {
      this.vehicleMap.removeLayer(this.vehMarker);
    }

    // Use the new tracking-style icon system
    const iconUrl = this.getMapVehicleIconUrl(this.VhcleDetails);
    const iconAngle =
      this.VhcleDetails.direction || this.VhcleDetails.drcn_ct || 0;

    var vehIcon = new L.Icon({
      iconUrl: iconUrl,
      iconSize: [100, null],
      iconAnchor: [37, 37],
      popupAnchor: [0, 0],
      shadowSize: [55, 55],
    });

    console.log(
      this.VhcleDetails.lat,
      this.VhcleDetails.lng,
      "Latlangsssssssssssssssssss"
    );
    if (this.VhcleDetails.lat && this.VhcleDetails.lng) {
      const popupContent = `
        <div class="popup-content">
          <div class="popup-title">${
            this.VhcleDetails.asrt_nm || "Unknown Vehicle"
          }</div>
          <div class="popup-row"><span class="popup-label">Category:</span> <span class="popup-value">${
            this.VhcleDetails.asrt_ctgry_nm || "N/A"
          }</span></div>
          <div class="popup-row"><span class="popup-label">Group:</span> <span class="popup-value">${
            this.VhcleDetails.asrt_grp_nm || "N/A"
          }</span></div>
          <div class="popup-row"><span class="popup-label">Speed:</span> <span class="popup-value speed">${
            this.VhcleDetails.speed_ct || 0
          } km/h</span></div>
          <div class="popup-row"><span class="popup-label">Status:</span> <span class="popup-value">${
            this.VhcleDetails.live_status ||
            this.VhcleDetails.asrt_sts_nm ||
            "N/A"
          }</span></div>
        </div>
      `;

      this.vehMarker = L.marker(
        [this.VhcleDetails.lat, this.VhcleDetails.lng],
        {
          icon: vehIcon,
        }
      ).addTo(this.vehicleMap);

      // Try to set rotation if available
      if ((this.vehMarker as any).setRotationAngle) {
        (this.vehMarker as any).setRotationAngle(iconAngle + 270);
      }

      this.vehMarker
        .bindPopup(popupContent, {
          className: "vehicle-popup-white",
          maxWidth: 280,
          offset: [0, -10],
        })
        .openPopup();

      var bounds = [];
      bounds.push([this.VhcleDetails.lat, this.VhcleDetails.lng]);
      this.vehicleMap.fitBounds(bounds);
    }
  }
  // Add to class properties:
  schdMarkerGroup: any = null;

  clearPrevMarkers() {
    // Use a LayerGroup to manage schdStartMarker and schdEndMarker
    if (this.schdMarkerGroup) {
      this.schdMarkerGroup.clearLayers();
      if (this.vehicleMap && this.vehicleMap.hasLayer(this.schdMarkerGroup)) {
        this.vehicleMap.removeLayer(this.schdMarkerGroup);
      }
      this.schdMarkerGroup = null;
    }
    this.schdStartMarker = null;
    this.schdEndMarker = null;
    if (this.vehMarker) {
      this.vehicleMap.closePopup();
      this.vehicleMap.removeLayer(this.vehMarker);
    }
    if (this.schdPolylineArry) {
      for (let s = 0; s < this.schdPolylineArry.length; s++) {
        this.vehicleMap.removeLayer(this.schdPolylineArry[s].plylns);
      }
    }
    if (this.trvld_Polyline) {
      this.vehicleMap.removeLayer(this.trvld_Polyline);
    }
    if (this.crclArry) {
      for (let c = 0; c < this.crclArry.length; c++) {
        this.vehicleMap.removeLayer(this.crclArry[c].crcls);
      }
    }
  }
  showStoppages() {
    if (this.VhcleDetails.stps_morethn_five > 0) {
      this.shwStpgWndw = true;
      this.stpgData = [];
      this.apiServ
        .get(`dashboard/enterprise/vehicles/stops/${this.selectedVehicle}`)
        .subscribe((res) => {
          if (res["status"] == 200) {
            this.stpgData = res["data"];
            this.stpgcolumnDefs = [
              {
                field: "sno",
                headerName: "Sno",
                visible: true,
                width: 80,
                alignment: "center",
                filter: true,
              },
              {
                field: "asrt_nm",
                headerName: "Vehicle",
                visible: true,
                width: 120,
                alignment: "center",
                filter: true,
              },
              {
                field: "asrt_ctgry_nm",
                headerName: "Vehicle Category",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
              {
                field: "asrt_stp_strt_ts",
                headerName: "Stopage start time",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
              {
                field: "asrt_stp_end_ts",
                headerName: "Stopage end time",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
              {
                field: "duration",
                headerName: "Stopage duration (Min)",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
              {
                field: "adrs_tx",
                headerName: "Address",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
            ];
          }
        });
    }
  }
  closeStpgSideBar() {
    this.shwStpgWndw = false;
  }
  handleOk() {
    this.shwStpgWndw = false;
  }
  vewonMap(f) {
    console.log(f);
    var latitude = f.lat;
    var longitude = f.lng;
    var mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(mapUrl, "_blank");
  }
  goToPlayback(t) {
    console.log(t);
    let data = {
      asrt_id: t.asrt_id,
      asrt_nm: t.VEHICLE,
      trp_rn_id: t.TRIP_ID,
      trp_sqnc_nu: t.trp_sqnc_nu,
      actl_strt_ts: t.actl_strt_ts,
      actl_strt: t.actl_strt_ts,
      actl_end_ts: t.actl_end_ts,
      actl_end: t.actl_end_ts,
      tnt_id: t.tnt_id,
      clnt_id: t.clnt_id,
    };
    this.TransfereService.setLoclData("plybckDta", data);

    this.router.navigate([`internal/play-back/list`]);
  }
  createMessage(type: string, msg: string): void {
    this.message.create(type, msg);
  }

  toggleFilterPanel() {
    this.filterPanelOpen = !this.filterPanelOpen;
  }

  toggleShowMore() {
    this.showMoreDetails = !this.showMoreDetails;
  }

  toggleVehicleList() {
    this.vehicleListOpen = !this.vehicleListOpen;
  }

  /**
   * Gets the vehicle icon path based on icon_path and live_status
   * @param item Vehicle data object
   * @returns Complete icon path string
   */
  getVehicleIconPath(item: any): string {
    const basePath = "assets/images/markers/mapIcons/";
    const iconBase = item.icon_path || "truck";

    // Use live_status from API for determining icon suffix
    // Running = _r, Parked = _p, Offline = _o
    if (item.live_status === "Running") {
      return `${basePath}${iconBase}_r.png`;
    } else if (item.live_status === "Parked") {
      return `${basePath}${iconBase}_p.png`;
    } else {
      return `${basePath}${iconBase}_o.png`; // Offline or any other status
    }
  }

  getFuelFillingData(asrt_id) {
    this.fuelFillingData = [];
    this.fuelFillingMsg = "";
    this.showLdr = true;
    this.apiServ.get(`drivers/fuel/${asrt_id}`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.fuelFillingData = res["data"];
          if (this.fuelFillingData && this.fuelFillingData.length > 0) {
            this.fuelConsumed = this.fuelFillingData.reduce(
              (sum, item) => sum + (item.fl_qty || 0),
              0
            );
            this.fuelFillingMsg = "";
          } else {
            this.fuelFillingMsg =
              "No fuel filling data found for this vehicle.";
            this.fuelConsumed = 0;
          }
        }
        this.showLdr = false;
      },
      (err) => {
        this.showLdr = false;
        this.fuelFillingMsg = "Error fetching fuel data.";
      }
    );
  }

  getFuelChartData(asrt_id) {
    this.fuelChartData = [];
    this.fuelChartMsg = "";
    if (this.fuelChart) {
      this.fuelChart.dispose();
      this.fuelChart = null;
    }
    this.apiServ.get(`drivers/fuel/chart/${asrt_id}`).subscribe(
      (res) => {
        if (res["status"] == 200 && res["data"] && res["data"].length > 0) {
          this.fuelChartData = res["data"];
          this.fuelChartMsg = "";
          setTimeout(() => {
            this.createFuelChart();
          }, 300);
        } else {
          this.fuelChartMsg = "No fuel data available";
          this.fuelChartData = [];
        }
      },
      (err) => {
        this.fuelChartMsg = "Error fetching fuel chart data.";
        this.fuelChartData = [];
      }
    );
  }

  createFuelChart() {
    if (this.fuelChart) {
      this.fuelChart.dispose();
    }
    if (!this.fuelChartData || this.fuelChartData.length === 0) {
      return;
    }

    // Ensure the container exists
    const chartContainer = document.getElementById("fuelChartDiv");
    if (!chartContainer) {
      console.warn("Fuel chart container not found");
      return;
    }

    am4core.useTheme(am4themes_animated);
    this.fuelChart = am4core.create("fuelChartDiv", am4charts.XYChart);
    this.fuelChart.paddingRight = 20;
    this.fuelChart.responsive.enabled = true;
    this.fuelChart.data = this.fuelChartData.map((item) => ({
      date: item.fl_date,
      quantity: parseFloat(item.fl_qty || 0),
      amount: parseFloat(item.fl_amnt || 0),
    }));

    let dateAxis = this.fuelChart.xAxes.push(new am4charts.CategoryAxis());
    dateAxis.dataFields.category = "date";
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.renderer.minGridDistance = 30;
    dateAxis.renderer.labels.template.fontSize = 12;
    dateAxis.renderer.labels.template.fill = am4core.color("#334155");
    dateAxis.title.text = "Date";
    dateAxis.title.fontSize = 12;
    dateAxis.title.fontWeight = "600";

    let valueAxis = this.fuelChart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = "Quantity (Ltr)";
    valueAxis.title.fontSize = 12;
    valueAxis.title.fontWeight = "600";
    valueAxis.renderer.labels.template.fontSize = 12;
    valueAxis.renderer.labels.template.fill = am4core.color("#334155");
    valueAxis.min = 0;

    let series = this.fuelChart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "quantity";
    series.dataFields.categoryX = "date";
    series.name = "Fuel Quantity";
    series.columns.template.tooltipText =
      "Date: {categoryX}\nQuantity: {valueY} Ltr";
    series.columns.template.fill = am4core.color("#f59e0b");
    series.columns.template.stroke = am4core.color("#d97706");
    series.columns.template.strokeWidth = 1;
    series.columns.template.column.cornerRadiusTopLeft = 4;
    series.columns.template.column.cornerRadiusTopRight = 4;
    series.columns.template.width = am4core.percent(60);

    this.fuelChart.cursor = new am4charts.XYCursor();
    this.fuelChart.cursor.lineX.strokeOpacity = 0;
    this.fuelChart.cursor.lineY.strokeOpacity = 0;

    // Force chart to render
    this.fuelChart.invalidateData();
  }

  // Auto-refresh methods
  ngOnDestroy() {
    this.stopAutoRefresh();
  }

  startAutoRefresh() {
    if (this.autoRefreshInterval) return;

    this.refreshCountdown = 30;
    this.autoRefreshEnabled = true;

    // Start countdown timer
    this.countdownInterval = setInterval(() => {
      this.refreshCountdown--;
      if (this.refreshCountdown <= 0) {
        this.refreshCountdown = 30;
      }
    }, 1000);

    // Start auto-refresh interval (every 30 seconds)
    this.autoRefreshInterval = setInterval(() => {
      this.refreshVehicleList();
    }, 30000);
  }

  stopAutoRefresh() {
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
      this.autoRefreshInterval = null;
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    this.autoRefreshEnabled = false;
    this.refreshCountdown = 30;
  }

  toggleAutoRefresh() {
    if (this.autoRefreshEnabled) {
      this.stopAutoRefresh();
    } else {
      this.startAutoRefresh();
    }
  }

  refreshVehicleList() {
    // Refresh vehicle list data without showing loader
    this.postslctdDt = {
      dt: this.currentDate,
      selectedtenant: this.selectedtenant,
      selectedctgry: this.selectedCtgry,
      selectedvndr: this.selectedvndr,
      tnt_in: 1,
    };
    const rte = `dashboard/enterprise/total_vehicles`;
    this.apiServ.post(this.postslctdDt, rte).subscribe((res) => {
      if (res["status"] == 200) {
        var res_data = res["data"];
        if (res_data) {
          // Preserve selected vehicle state
          const selectedAsrtId = this.selectedVehicle;
          this.ttl_veh = res["data"];
          for (let i = 0; i < this.ttl_veh.length; i++) {
            this.ttl_veh[i]["apply_actv"] =
              this.ttl_veh[i].asrt_id == selectedAsrtId ? 1 : 0;
          }
        }
      }
    });

    // Also refresh selected vehicle info and map if a vehicle is selected
    if (this.selectedVehicle) {
      this.refreshSelectedVehicleData();
    }
  }

  refreshSelectedVehicleData() {
    // Refresh vehicle info (updates vehicle details card)
    this.apiServ
      .get(`drivers/vehicles/vehicleById/${this.selectedVehicle}`)
      .subscribe((res) => {
        if (res["status"] == 200 && res["data"] && res["data"][0]) {
          this.VhcleDetails = res["data"][0];
          this.vehnm = this.VhcleDetails.asrt_nm;
          this.asrt_sts_nm = this.VhcleDetails.asrt_sts_nm;
          this.ctgrynm = this.VhcleDetails.asrt_ctgry_nm;
          this.grpnm = this.VhcleDetails.asrt_grp_nm;
          this.matchVehData = this.VhcleDetails;
          this.vehOdmtr = this.VhcleDetails.veh_odmtr_ct;
          this.devOdmtr = this.VhcleDetails.dvce_odmtr_ct;
          this.imei = this.VhcleDetails.dev_imei_nu;
          this.chasis = this.VhcleDetails.asrt_chses_nu;
          this.data_lst_rcvd = this.VhcleDetails.data_received_ts;
          this.speed = this.VhcleDetails.speed_ct;
          this.CrntDyDst = this.VhcleDetails.trp_dst;
          this.dst_tvl_tdy = this.VhcleDetails.tdy_dst;
          this.ignitionStatus =
            this.VhcleDetails.igntn_in == 1
              ? "ON"
              : this.VhcleDetails.igntn_in == 0
              ? "OFF"
              : "NA";

          // Update map marker position if showing current location
          if (this.shwCrntLoc) {
            this.updateVehicleMapMarker();
          }
        }
      });
  }

  updateVehicleMapMarker() {
    if (!this.VhcleDetails || !this.VhcleDetails.lat || !this.VhcleDetails.lng)
      return;

    const coords = [this.VhcleDetails.lat, this.VhcleDetails.lng];

    // Remove existing marker
    if (this.vehMarker) {
      this.vehicleMap.removeLayer(this.vehMarker);
    }

    // Get icon URL using the new icon system (like tracking component)
    const iconUrl = this.getMapVehicleIconUrl(this.VhcleDetails);
    const iconAngle =
      this.VhcleDetails.direction || this.VhcleDetails.drcn_ct || 0;

    // Add updated marker with tracking-style icon
    var bounds = L.latLngBounds([coords]);
    const icon = L.icon({
      iconUrl: iconUrl,
      iconSize: [100, null],
      iconAnchor: [37, 37],
      popupAnchor: [0, 40],
    });

    const popupContent = `
      <div class="popup-content">
        <div class="popup-title">${
          this.VhcleDetails.asrt_nm || "Unknown Vehicle"
        }</div>
        <div class="popup-row"><span class="popup-label">Category:</span> <span class="popup-value">${
          this.VhcleDetails.asrt_ctgry_nm || "N/A"
        }</span></div>
        <div class="popup-row"><span class="popup-label">Group:</span> <span class="popup-value">${
          this.VhcleDetails.asrt_grp_nm || "N/A"
        }</span></div>
        <div class="popup-row"><span class="popup-label">Speed:</span> <span class="popup-value speed">${
          this.VhcleDetails.speed_ct || 0
        } km/h</span></div>
        <div class="popup-row"><span class="popup-label">Status:</span> <span class="popup-value">${
          this.VhcleDetails.live_status ||
          this.VhcleDetails.asrt_sts_nm ||
          "N/A"
        }</span></div>
      </div>
    `;

    this.vehMarker = L.marker(coords, { icon: icon }).addTo(this.vehicleMap);

    // Try to set rotation if available
    if ((this.vehMarker as any).setRotationAngle) {
      (this.vehMarker as any).setRotationAngle(iconAngle + 270);
    }

    this.vehMarker
      .bindPopup(popupContent, {
        className: "vehicle-popup-white",
        maxWidth: 280,
        offset: [0, -10],
      })
      .openPopup();

    this.vehicleMap.fitBounds(bounds);
  }

  /**
   * Gets vehicle icon color based on status (like tracking component)
   */
  getMapVehicleIconColor(vehicle: any): string {
    // Offline vehicles (asrtglblId != 1 or asrt_glbl_sts_id != 1)
    if (vehicle.asrtglblId != 1 && vehicle.asrt_glbl_sts_id != 1) {
      return "gray";
    }

    // Online vehicles - determine by speed
    const speed = parseFloat(vehicle.speed_ct || vehicle.spd_ct) || 0;
    const diffTimeInMin = Number(vehicle.diffTimeInMin) || 0;

    // Running (speed > 5)
    if (speed > 5) {
      return "green";
    }

    // Stationed/parked (speed <= 5)
    if (speed <= 5) {
      if (diffTimeInMin >= 15) {
        return "red"; // stationedLong
      } else if (diffTimeInMin >= 5) {
        return "yellow"; // stationedMedium
      }
      return "blue"; // stationedShort / recent park
    }

    return "blue";
  }

  /**
   * Gets the complete icon URL for vehicle on map (like tracking component)
   */
  getMapVehicleIconUrl(vehicle: any): string {
    const color = this.getMapVehicleIconColor(vehicle);

    // Determine icon base name from category
    let iconBaseName = "";

    if (vehicle.icon_path_new) {
      iconBaseName = vehicle.icon_path_new
        .replace(/\.png$/, "")
        .replace(/\.svg$/, "")
        .trim()
        .toLowerCase();
    } else if (vehicle.asrt_ctgry_nm) {
      iconBaseName = this.getVehicleIconBaseName(vehicle.asrt_ctgry_nm);
    } else if (vehicle.icon_path) {
      // Try to extract base name from old icon_path
      iconBaseName = vehicle.icon_path
        .replace(/_[rop]_m\.png$/, "")
        .replace(/_[rop]\.png$/, "")
        .replace(/\.png$/, "")
        .replace(/\.svg$/, "")
        .toLowerCase();
      // Map old icon names to new ones
      iconBaseName = this.getVehicleIconBaseName(iconBaseName);
    } else {
      iconBaseName = "car";
    }

    // Build new icon URL: assets/images/markers/mapIcons/m/new_icons/{iconBaseName}_{color}.png
    return `assets/images/markers/mapIcons/m/new_icons/${iconBaseName}_${color}.png`;
  }

  /**
   * Maps category name to icon base name
   */
  getVehicleIconBaseName(categoryName: string): string {
    if (!categoryName) return "car";

    const categoryLower = categoryName.toLowerCase().trim();
    const categoryMap: { [key: string]: string } = {
      // Auto variants
      auto: "auto",
      "auto tipper": "auto",
      "auto rickshaw": "auto",
      autorickshaw: "auto",
      auto_tipper: "auto",
      // Tractor variants
      tractor: "tractor",
      tractor_trolley: "tractor",
      "tractor trolley": "tractor",
      // Compactor variants
      compactor: "compactor",
      compactor_vehicle: "compactor",
      // Water tanker variants
      "water tanker": "watertank",
      "water tank": "watertank",
      watertanker: "watertank",
      water_tanker: "watertank",
      watertank: "watertank",
      // Van variants
      van: "van",
      "dogs van": "dogsvan",
      dogsvan: "dogsvan",
      dogs_van: "dogsvan",
      // Car variants
      car: "car",
      suv: "car",
      sedan: "car",
      // Sweeping variants
      sweeping: "sweeping",
      "sweeping machine": "sweeping",
      sweeping_machine: "sweeping",
      "road sweeper": "sweeping",
      // Hook loader variants
      "hook loader": "hookloader",
      hookloader: "hookloader",
      hook_loader: "hookloader",
      // JCB variants
      jcb: "jcb",
      excavator: "jcb",
      "earth mover": "jcb",
      // Lorry/Truck variants
      lorry: "lorry",
      truck: "lorry",
      "mini truck": "lorry",
      mini_truck: "lorry",
      // Tipper variants
      tipper: "tipper",
      dumper: "tipper",
      tipper_truck: "tipper",
      // Electric ladder variants
      "electric ladder": "electricladder",
      electricladder: "electricladder",
      electric_ladder: "electricladder",
      ladder: "electricladder",
      // Tree pruning variants
      "tree pruning": "treepruning",
      treepruning: "treepruning",
      tree_pruning: "treepruning",
      // Other common mappings
      garbage: "lorry",
      refuse: "lorry",
      dustbin: "van",
      pickup: "van",
      mini: "van",
    };

    if (categoryMap[categoryLower]) {
      return categoryMap[categoryLower];
    }

    // Try partial match
    for (const [key, value] of Object.entries(categoryMap)) {
      if (categoryLower.includes(key) || key.includes(categoryLower)) {
        return value;
      }
    }

    return "car";
  }

  manualRefresh() {
    this.refreshCountdown = 30;
    this.refreshVehicleList();
    this.message.success("Vehicle list refreshed");
  }

  // Helper methods for vehicle counts
  getRunningCount(): number {
    if (!this.ttl_veh) return 0;
    return this.ttl_veh.filter((v) => v.live_status === "Running").length;
  }

  getParkedCount(): number {
    if (!this.ttl_veh) return 0;
    return this.ttl_veh.filter((v) => v.live_status === "Parked").length;
  }

  getOfflineCount(): number {
    if (!this.ttl_veh) return 0;
    return this.ttl_veh.filter((v) => v.live_status === "Offline").length;
  }
}
